import AuthGuard from "./auth_guard";

export default [
    {
        path: '/video',
        name: 'video',
        component: () => import('../views/Cam/Cam.vue'),
        breadcrumbs: [
            { name: 'msg.videoMonitoring', customName: null, disabled: true, to: {} }
        ],
        beforeEnter: AuthGuard,
    },
]